// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"f97a1cb2","638":"85ab1733","658":"80345936","742":"0c5eb1a0"}[chunkId] + ".chunk.js";
};